export const navigateToHomePage = ({ navigation, params }: any) => {
  return navigation.navigate("Summary", {
    screen: "Home",
    params: {
      screen: "Home",
      params,
    },
  });
};
